import request, { resolve } from '../api/request';
import consts from '../app/constants';
import DesignCollectionStore from '../stores/DesignCollectionStore';

var hasPendingRequest = false;
const preLoadDistance = 2;

function appendDesignData(context, payload) {
    if (hasPendingRequest) return;
    hasPendingRequest = true;

    const apiRequest = request('GET', payload.nextPageUrl).set(
        'X-Requested-With',
        'XMLHttpRequest'
    );

    return resolve(apiRequest)
        .then(data => {
            hasPendingRequest = false;
            let collection = context
                .getStore(DesignCollectionStore)
                .getCollectionModel()
                .fromJSON(data);

            context.dispatch(consts.UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND, {
                designs: collection.designs,
                pageUrl: payload.nextPageUrl,
            });
        })
        .catch(e => {
            hasPendingRequest = false;
        });
}

function prependDesignData(context, payload) {
    if (hasPendingRequest) return;
    hasPendingRequest = true;

    const apiRequest = request('GET', payload.prevPageUrl).set(
        'X-Requested-With',
        'XMLHttpRequest'
    );

    return resolve(apiRequest)
        .then(data => {
            hasPendingRequest = false;
            let collection = context
                .getStore(DesignCollectionStore)
                .getCollectionModel()
                .fromJSON(data);

            context.dispatch(consts.UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND, {
                designs: collection.designs,
                pageUrl: payload.prevPageUrl,
            });
        })
        .catch(e => {
            hasPendingRequest = false;
        });
}

export function setDesignCollection(context, collection) {
    return Promise.resolve().then(() => context.dispatch(consts.SET_DESIGN_COLLECTION, collection));
}

export function setDesignData(context, payload) {
    return Promise.resolve().then(() =>
        context.dispatch(
            consts.SET_DESIGN_DATA,
            context
                .getStore(DesignCollectionStore)
                .getModel()
                .fromJSON(payload)
        )
    );
}

export function loadDesign(context, designId) {
    const collectionStore = context.getStore(DesignCollectionStore);
    const currentDesign = collectionStore.getDesign(designId);
    const apiRequest = request('GET', currentDesign.links.self, consts.LOAD_DESIGN_SUCCESS);

    return resolve(apiRequest)
        .then(response => {
            context.dispatch(
                consts.LOAD_DESIGN_SUCCESS,
                context
                    .getStore(DesignCollectionStore)
                    .getModel()
                    .fromJSON(response)
            );
        })
        .catch(e => {
            context.dispatch(consts.LOAD_DESIGN_FAILED);
            throw e;
        });
}

export function loadMoreDesigns(context, designId) {
    const collectionStore = context.getStore(DesignCollectionStore);
    const currentDesign = collectionStore.getDesign(designId);
    const designs = collectionStore.designs;
    const nextPageUrl = collectionStore.nextPageUrl;
    const prevPageUrl = collectionStore.prevPageUrl;

    const index = designs.indexOf(currentDesign);

    if (nextPageUrl && !designs[index + preLoadDistance]) {
        return appendDesignData(context, {
            nextPageUrl: nextPageUrl,
        });
    }

    if (prevPageUrl && index - preLoadDistance < 0) {
        return prependDesignData(context, {
            prevPageUrl: prevPageUrl,
        });
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/actions/set-design-data.js